module.exports = __webpack_public_path__ + "static/media/Sally-Edwards.f2df6770.jpg";